import React, { useRef } from "react";
import { Transition } from "react-transition-group";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { OcAvatar } from "oc/components";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";
import { getFullname } from "oc/utils";

type MyHrStickyPersonalDataHeaderProps = {
  pageWidth: number;
  employee: any;
  contract: any;
  trigger: boolean;
};

export const MyHrStickyPersonalDataHeader: React.FC<
  MyHrStickyPersonalDataHeaderProps
> = ({ pageWidth, employee, contract, trigger }) => {
  const theme = useTheme();
  const duration = 250;
  const isMobile = useOcIsMobile();

  const transitionRef = useRef(null);

  const jobClassName =
    contract?.jobClass?.name.charAt(0).toUpperCase() +
    contract?.jobClass?.name.slice(1) || "undefined";

  if (isMobile) {
    return null;
  }

  return (
    <Transition in={trigger} timeout={duration} nodeRef={transitionRef}>
      {(state) => (
        <Box
          id="my-hr-sticky-menu-data"
          ref={transitionRef}
          position="fixed"
          height="48px"
          bgcolor={theme.palette.gray20.main}
          width={pageWidth > 0 ? `${pageWidth}px` : "100%"}
          zIndex="1110"
          display="flex"
          flexDirection="row"
          alignItems="center"
          style={{
            overflow: "hidden",
            transition: `height ${duration}ms ease-in-out`,
            height:
              state === "entered" || state === "entering" ? "48px" : "0px",
          }}
        >
          <Box width="72px" paddingLeft="24px">
            <OcAvatar
              employee={employee?.code}
              style={{
                width: "48px",
                height: "48px",
              }}
            />
          </Box>
          <Box
            flexGrow={1}
            display="flex"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
          >
            <Box style={{ overflow: "hidden" }}>
              <Typography noWrap variant="h4">
                {getFullname(employee)}
              </Typography>
            </Box>
            <Box paddingLeft="24px" style={{ overflow: "hidden" }}>
              <Typography noWrap variant="h5">
                {jobClassName}
              </Typography>
            </Box>
          </Box>
          <Box width="72px" minWidth="72px" />
        </Box>
      )}
    </Transition>
  );
};

export default MyHrStickyPersonalDataHeader;
